import { render, staticRenderFns } from "./CampaignsCRM.vue?vue&type=template&id=5eaf148e&scoped=true"
import script from "./CampaignsCRM.vue?vue&type=script&lang=js"
export * from "./CampaignsCRM.vue?vue&type=script&lang=js"
import style0 from "./CampaignsCRM.vue?vue&type=style&index=0&id=5eaf148e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf148e",
  null
  
)

export default component.exports